import React from 'react'
import {
  
  BayerLeverkusen, 
  BayernMunich, 
  WerderBremen, 
  BorussiaDortmund, 
  VfBStuttgart,
  BorussiaMonchengladbach,
  HamburgerSV,
  Kaiserslautern,
  FCKoln,
  EintrachtBraunschweig,
  EighteenSixtyMunich

} from "../clubs";

const Bundesliga = () => {
  return (
    <div>
    <h1>Dates of the last league titles for each club that has won Bundesliga.</h1>
    <BayernMunich />
    <BayerLeverkusen />
    <BorussiaDortmund />
    <VfBStuttgart />
    <WerderBremen />
    <Kaiserslautern />
    <HamburgerSV />
    <FCKoln />
    <BorussiaMonchengladbach />
    <EintrachtBraunschweig />
    <EighteenSixtyMunich />
    
    
    </div>
  )
}

export default Bundesliga